import {
    FamilyDetailView,
    GroupDisplay,
    PackageRevisionDetailView,
    ItemDetailRevision,
    PostItemDetailRevision,
    PostPackageRevisionDetailView,
    PostrevisionDetailView,
    PostRevisionItemDetailView,
    RevisionDetailView,
    RevisionItemDetailView,
    UpdateOrder,
    PostItemPackageDetailView,
    ItemPackageDetailView,
    PostFamilyDetailView,
    ExhibitionLayout,
    ResponseUpdateCardapio,
    PostUpdateFamily,
    Installment,
    PostPackageUpdate,
    ItemDescription,
    PostPackageItemUpdate,
    UpdateCar,
    PostUpdateRevision,
    PostUpdateUpdateRevisionItem,
    PostcreateAndEditPackage,
    TreeInitial,
    EditPackage
} from "@/models/CardapioModel";
import ApiService from "./ApiService";

const getTreeInitial = async (codConcessionaria: number) : Promise<TreeInitial[]> => {
    const { data } = await ApiService.get(`/cardapio/treeInitial/${codConcessionaria}`);
    return data;
};

const getVehicles = async (postData) => {
    const { data } = await ApiService.post(`cardapio/veiculo`, postData);
    return data;
};

const getPackages = async (postData) => {
    const { data } = await ApiService.post(`cardapio/veiculo/pacotes`, postData);
    return data;
};

const getPackage = async (postData) => {
    const { data } = await ApiService.post(`cardapio/veiculo/pacote`, postData);
    return data;
};

const getPackageDetail = async (postData) => {
    const { data } = await ApiService.post(`cardapio/veiculo/pacote/detalhe`, postData);
    return data;
};

const itemDisplay = async (codConcessionaria: number): Promise<GroupDisplay> => {
    const { data } = await ApiService.get(`cardapio/detalhe/item/${codConcessionaria}`);
    return data;
};

const updateOrder = async (postData: UpdateOrder) => {
    const { data } = await ApiService.post(`cardapio/detalhe/ordem`, postData as object);
    return data;
};

const familyDetailView = async (postData: PostFamilyDetailView): Promise<FamilyDetailView> => {
    const { data } = await ApiService.post(`cardapio/detalhe/familia`, postData as object);
    return data;
};

const revisionDetailView = async (postData: PostrevisionDetailView): Promise<RevisionDetailView> => {
    const { data } = await ApiService.post(`cardapio/detalhe/revisao`, postData as object);
    return data;
}

const revisionItemDetailView = async (postData: PostRevisionItemDetailView): Promise<RevisionItemDetailView> => {
    const { data } = await ApiService.post(`cardapio/detalhe/revisao/item`, postData as object);
    return data;
}

const itemRevisionDetailView = async (postData: PostItemDetailRevision): Promise<ItemDetailRevision> => {
    const { data } = await ApiService.post(`cardapio/detalhe/revisao/item/servico`, postData as object);
    return data;
}

const packageRevisionDetailView = async (postData: PostPackageRevisionDetailView): Promise<PackageRevisionDetailView> => {
    const { data } = await ApiService.post(`cardapio/detalhe/revisao/pacote`, postData as object);
    return data;
}

const itemPackageDetailView = async (postData: PostItemPackageDetailView): Promise<ItemPackageDetailView> => {
    const { data } = await ApiService.post(`cardapio/detalhe/pacote/item`, postData as object);
    return data;
}

const exhibitionLayout = async (): Promise<ExhibitionLayout[]> => {
    const { data } = await ApiService.get(`/layout-exibicao`);
    return data;
};

const updateFamily = async (postData: PostUpdateFamily): Promise<ResponseUpdateCardapio> => {
    const { data } = await ApiService.post(`update/familia`, postData as object);
    return data;
}

const updatePackage = async (postData: PostPackageUpdate): Promise<ResponseUpdateCardapio> => {
    const { data } = await ApiService.post(`update/pacote`, postData as object);
    return data;
}

const updatePackageItem = async (postData: PostPackageItemUpdate): Promise<ResponseUpdateCardapio> => {
    const { data } = await ApiService.post(`update/pacote/item`, postData as object);
    return data;
}

const updateCar = async (postData: UpdateCar): Promise<ResponseUpdateCardapio> => {
    const { data } = await ApiService.post(`/update/carro`, postData as object);
    return data;
}

const updateRevision = async (postData: PostUpdateRevision): Promise<ResponseUpdateCardapio> => {
    const { data } = await ApiService.post(`/update/revisao`, postData as object);
    return data;
}

const updateRevisionItem = async (postData: PostUpdateUpdateRevisionItem): Promise<ResponseUpdateCardapio> => {
    const { data } = await ApiService.post(`/update/revisao/item`, postData as object);
    return data;
}

const installment = async (): Promise<Installment[]> => {
    const { data } = await ApiService.get(`/parcela`);
    return data;
};

const itemDescription = async (): Promise<ItemDescription[]> => {
    const { data } = await ApiService.get(`/descricao-item`);
    return data;
};

const createdItemPackage = async (postData): Promise<{ error: string, message: string }> => {
    const { data } = await ApiService.post(`/adicionar-item`, postData as object);
    return data;
}

const cardapioAlacarte = async (codConcessionaria: number | string): Promise<string[]> => {
    const { data } = await ApiService.get(`cardapio-alacarte/${codConcessionaria}`);
    return data;
};

const createAndEditPackage = async (postData: PostcreateAndEditPackage): Promise<{
    error: boolean,
    message: string
}> => {
    const { data } = await ApiService.post(`cardapio/pacote`, postData as object);
    return data;
}

const packageSelect= async (postData : {codConcessionaria: string, codPacote: string}): Promise<EditPackage> => {
    const { data } = await ApiService.post(`/cardapio/pacote/editar`, postData as object);
    return data;
}

export {
    getTreeInitial,
    getVehicles,
    getPackages,
    getPackage,
    getPackageDetail,
    itemDisplay,
    updateOrder,
    familyDetailView,
    revisionDetailView,
    revisionItemDetailView,
    itemRevisionDetailView,
    packageRevisionDetailView,
    itemPackageDetailView,
    exhibitionLayout,
    updateFamily,
    installment,
    itemDescription,
    updatePackage,
    updatePackageItem,
    updateCar,
    updateRevision,
    updateRevisionItem,
    createdItemPackage,
    cardapioAlacarte,
    createAndEditPackage,
    packageSelect
}